import { render, staticRenderFns } from "./partyForm.vue?vue&type=template&id=bb35ba08&"
import script from "./partyForm.vue?vue&type=script&lang=js&"
export * from "./partyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports